import React from 'react';

const CategoryLabel = ({ data }) => {
    return (
        <div
            id="boot"
            style={{
                background: 'transparent',
                margin: 6,
                cursor: 'initial !important'
            }}
        >
            <span
                className={'label category-label category-' + data.id}
                style={{
                    float: 'left',
                    padding: '2px 8px 2px 8px'
                }}
            >
                {data.name}
            </span>
        </div>
    );
};

export default CategoryLabel;
